import { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// home pages
const HomeBookStore = lazy(() => import("./pages/home/HomeBookStore"));

// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));
const CustomDesign = lazy(() => import("./pages/other/CustomDesign"));
const PostcardsPage = lazy(() => import("./pages/other/PostcardsPage"));
const PricingInquiry = lazy(() => import("./pages/other/PricingInquiry"));
const WhyPostcardBay = lazy(() => import("./pages/other/WhyPostcardBay"));
const WhatWeDo = lazy(() => import("./pages/other/WhatWeDo"));

// PostCard Bay pages
const CookiePolicy = lazy(() => import("./pages/pb-pages/CookiePolicy"));
const PrivacyPolicy = lazy(() => import("./pages/pb-pages/PrivacyPolicy"));
const RefundPolicy = lazy(() => import("./pages/pb-pages/RefundPolicy"));
const CustomerAssistance = lazy(() =>
  import("./pages/pb-pages/CustomerAssitance")
);
const TermsAndServices = lazy(() =>
  import("./pages/pb-pages/TermsAndServices")
);
const Feedback = lazy(() => import("./pages/pb-pages/Feedback"));
const AcceptedFileFormats = lazy(() =>
  import("./pages/pb-pages/AcceptedFileFormats")
);
const Faq = lazy(() => import("./pages/pb-pages/Faq"));
const Vulnerability = lazy(() => import("./pages/pb-pages/Vulnerability"));
const ThankYou = lazy(() => import("./pages/pb-pages/ThankYou"));
const FreeFileCheck = lazy(() => import("./pages/pb-pages/FreeFileCheck"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="flone-preloader-wrapper">
              <div className="flone-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            <Route
              path={process.env.PUBLIC_URL + "/"}
              element={<HomeBookStore />}
            />

            {/**PB pages */}
            <Route
              path={process.env.PUBLIC_URL + "/cookies-policy"}
              element={<CookiePolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/privacy-policy"}
              element={<PrivacyPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/refund-policy"}
              element={<RefundPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/thank-you"}
              element={<ThankYou />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/free-file-check"}
              element={<FreeFileCheck />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/customer-assistance-policy"}
              element={<CustomerAssistance />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/terms-and-service"}
              element={<TermsAndServices />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/feedback"}
              element={<Feedback />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/accepted-file-formats"}
              element={<AcceptedFileFormats />}
            />
            <Route path={process.env.PUBLIC_URL + "/faq"} element={<Faq />} />
            <Route
              path={process.env.PUBLIC_URL + "/vulnerability"}
              element={<Vulnerability />}
            />

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/about"}
              element={<About />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/my-account"}
              element={<MyAccount />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/login-register"}
              element={<LoginRegister />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />
            <Route
              path={process.env.PUBLIC_URL + "/wishlist"}
              element={<Wishlist />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/compare"}
              element={<Compare />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/checkout"}
              element={<Checkout />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/custom-design"}
              element={<CustomDesign />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/postcards"}
              element={<PostcardsPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/pricing-inquiry"}
              element={<PricingInquiry />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/why-postcardbay"}
              element={<WhyPostcardBay />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/what-we-do"}
              element={<WhatWeDo />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
